import type {
  ICryptoAdapter,
  IDatabaseService,
  IDatabaseSnapshotPort,
  IMetadataKeyRepository,
} from '@app/domain/ports';
import { EncryptedDatabaseSnapshotWriter } from './encrypted-database-snapshot.writer';

export class DatabaseSnapshotAdapter implements IDatabaseSnapshotPort {
  private readonly writer: EncryptedDatabaseSnapshotWriter;

  constructor(
    private readonly databaseService: Pick<IDatabaseService, 'exportDatabase'>,
    crypto: Pick<ICryptoAdapter, 'encryptRaw'>,
    metadataRepository: Pick<IMetadataKeyRepository, 'set'>,
  ) {
    this.writer = new EncryptedDatabaseSnapshotWriter(crypto, metadataRepository);
  }

  async persistEncryptedSnapshot(dek: CryptoKey): Promise<void> {
    const data = await this.databaseService.exportDatabase();
    await this.writer.persist(data, dek);
  }
}

export class NoopDatabaseSnapshotAdapter implements IDatabaseSnapshotPort {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async persistEncryptedSnapshot(_dek: CryptoKey): Promise<void> {
    return;
  }
}
